<template>
  <div>
    <Messages :messages="messages"/>
    <div class="container" v-if="existsRecord" v-cloak>
      <h2>Consulta de constancias de Servicio Social</h2>
      <br/>
      <div class="bg-secondary text-white font-weight-bold px-3 py-2 rounded d-inline-block">
        Datos del alumno
      </div>
      <hr>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Matrícula:"
                    label-for="input-sm">
        <b-form-input id="studentNameId" size="sm"
                      v-bind:value="recordData.idEnrollment"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Nombre:"
                    label-for="input-sm">
        <b-form-input id="studentNameId" size="sm"
                      v-bind:value="recordData.studentName"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="CURP:"
                    label-for="input-sm">
        <b-form-input id="studentCURP" size="sm"
                      v-bind:value="recordData.studentCURP"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Institución educativa:"
                    label-for="input-sm">
        <b-form-input id="educationalInstitutionId" size="sm"
                      v-bind:value="recordData.educationalInstitution"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Carrera:"
                    label-for="input-sm">
        <b-form-input id="programId" size="sm"
                      v-bind:value="recordData.program"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Folio:"
                    label-for="input-sm">
        <b-form-input id="folioId" size="sm"
                      v-bind:value="recordData.folio"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Empresa donde realizó el Servicio Social:"
                    label-for="input-sm">
        <b-form-input size="sm"
                      v-bind:value="recordData.company"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Fecha de inicio:"
                    label-for="input-sm">
        <b-form-input id="startDateId" size="sm"
                      v-bind:value="recordData.startDate"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Fecha de término:"
                    label-for="input-sm">
        <b-form-input id="endDateId" size="sm"
                      v-bind:value="recordData.endDate"
                      readonly>
        </b-form-input>
      </b-form-group>
      <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                    label="Créditos al inicio Servicio Social:"
                    label-for="input-sm">
        <b-form-input id="creditsId" size="sm"
                      v-bind:value="recordData.credits"
                      readonly>
        </b-form-input>
      </b-form-group>
      <div class="row">
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Messages from "../components/Messages.vue"

export default {

  components: {
    Messages
  },

  data: () => ({
    existsRecord: false,
    recordData: {},
    showLoader: false,
    messages: {
      info: "",
      error: "",
      warning: ""
    }
  }),

  computed: {
    ...mapGetters({
      record: "record/record",
    }),
  },

  mounted () {
    this.initialize()
  },

  methods: {
    initialize () {
      console.log("Record in URL" + this.$route.query.folio)
      this.showLoader = true,
      this.$store
            .dispatch("record/getRecordSocialServiceUser", this.$route.query.folio)
            .then((response) => {
              this.recordData = response
              this.existsRecord = response != null ? true : false
              this.showLoader = false
            })
            .catch( error => {
              console.log(error)
              this.messages.info = "Constancia no encontrada."
              this.existsRecord = false
              this.showLoader = false
            })
    },
  }
}
</script>